<template>
	<div class="formTabWrapper">
		<div class="formTabTableWrap">
			<div class="formTabTableWrap_top">
				<div class="formTabTableWrap_top-title">Notes</div>
				<div class="formTabTableWrap_top-add">

					<v-btn
							:disabled="getPermissionAction" @click="onNotesDrawer(true)" type="button"
							depressed
							class="mainBtn mainBtn-text"
					>
						<span class="btnIco"><svg-sprite icon-id="addItem" width="20" height="20"></svg-sprite></span>
						<span class="btnText">Add note</span>
					</v-btn>

				</div>
			</div>
			<div class="formTabTableWrap_body">
				<notes
						v-if="trailerNotesFilter"
						:filter="trailerNotesFilter"
						:items="trailerNotesList"
						:trailerId="trailerId"
						:getPermissionAction="getPermissionAction"
						@updateEdit="onEdit"
						@updateRemoveItem="setRemoveItem"
				></notes>
			</div>
		</div>

		<notes-drawer
				v-if="isNotesDrawer"
				:editItem="editItem"
				@closeDrawer="onNotesDrawer(false)"
				@updateSave="onSave"
		></notes-drawer>

		<remove-block
				v-if="isRemove"
				@updateRemoveItem="onRemoveItem"
				@updateRemoveClose="isRemove = false"
		></remove-block>
	</div>

</template>

<script>
// vuex
import { mapActions, mapGetters } from "vuex";
// components
import Notes from "@/components/Maintenance/Trailers/TrailersForm/Notes/Notes";
// async components
const NotesDrawer =
		() => import("@/shared/Drawers/NotesDrawer/NotesDrawer");
const RemoveBlock = () => import("@/shared/RemoveBlock/RemoveBlock");

export default {
	name: "FourthTab",
	components: {
		Notes,
		NotesDrawer,
		RemoveBlock
	},
	computed: mapGetters([ 'trailerNotesFilter', 'trailerNotesList' ]),
	props: {
		trailerId: Number,
		getPermissionAction: Boolean
	},
	data: () => ({
		isNotesDrawer: false,
		editItem: null,
		isRemove: false,
		removeItem: null,
	}),
	methods: {
		...mapActions([ 'onTrailerNotes', 'onTrailerNotesCreate', 'onTrailerNotesRemove' ]),
		async onSave(values) {
			await this.onTrailerNotesCreate({ trailerId: this.trailerId, values });
			this.isNotesDrawer = false;
			this.editItem = null;
		},
		onNotesDrawer(value) {
			this.isNotesDrawer = value;
			if (!value) this.editItem = null;
		},
		async onEdit(item) {
			this.editItem = item;
			this.isNotesDrawer = true;
		},
		async setRemoveItem(id) {
			this.removeItem = { trailerId: this.trailerId, id };
			this.isRemove = true;
		},
		async onRemoveItem() {
			await this.onTrailerNotesRemove(this.removeItem);
			this.isRemove = false;
		}
	},
	async mounted() {
		await this.onTrailerNotes(this.trailerId);
	}
};
</script>

<style scoped lang="scss">
@import "@/assets/style/components/formTab/formTabTableWrap";
</style>
